import React, { useState, useMemo } from "react";
import { Container } from "reactstrap";
import { useSelector } from "react-redux";

import { DF_OT0019Context } from "./context";
import GridHeader from "./Grid/GridHeader";
import GridBody from "./Grid/GridBody";

import { fnGetValueByKey } from "../../../helpers/functions";
import withRouter from "../../../components/Common/withRouter";
import useGetCsrfToken from "../../../Hooks/useGetCsrfToken";

const DF_OT0019 = (props) => {
  const navigate = props.router?.navigate || props.navigate;

  const userProfile = useSelector((state) => state.login.profile);
  const isModalPage = useSelector((state) => state.Layout.isModalPage);
  const accessToken = useSelector((state) => state.login.user?.access_token);

  const csrfToken = useGetCsrfToken();

  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({});

  const contextValue = useMemo(
    () => ({
      isLoading,
      setIsLoading,
      formData,
      setFormData,
      userProfile,
      accessToken,
      csrfToken,
      fnGetValueByKey,
      navigate,
    }),
    [
      isLoading,
      setIsLoading,
      formData,
      setFormData,
      userProfile,
      accessToken,
      csrfToken,
      navigate,
    ]
  );

  const containerClasses = `page-content min-vh-100 ${
    isModalPage ? "p-0 overflow-hidden" : "overflow-visible"
  }`;

  return (
    <DF_OT0019Context.Provider value={contextValue}>
      <div className={containerClasses}>
        <Container fluid className="dataTable-custom-primary">
          <GridHeader />
          <GridBody />
        </Container>
      </div>
    </DF_OT0019Context.Provider>
  );
};

export default withRouter(DF_OT0019);